<template>
  <span
    class="stars"
    ref="stars"
  ></span>
</template>

<script>
    export default {
        props: {
            count: [Number, String],
        },
        mounted() {
            this.$refs.stars.innerHTML = this.generateStarsHtml(this.count);
        },
        methods: {
            generateStarsHtml(count) {
                var fullStar = '<span class="star full"></span>';
                var emptyStar = '<span class="star empty"></span>';
                var halfFullStar = '<span class="star half"></span>';
                var i = 1;
                var result = "";
                while (i <= 5) {
                    if (count >= i) {
                        result += fullStar;
                    } else if (i - count < 1) {
                        result += halfFullStar;
                    } else {
                        result += emptyStar;
                    }
                    i++;
                }
                return result;
            },
        },
    };
</script>

<style lang="less" scoped>
    .stars {
        display: flex;
        margin-right: 10px;

        ::v-deep {
            .star {
                background-size: 10px 10px;
                background-position: center center;
                background-repeat: no-repeat;
                display: inline-flex;
                width: 10px;
                height: 10px;
                margin-right: 4px;

                &.full {
                    background-image: url("../assets/img/star.png");
                }

                &.empty {
                    background-image: url("../assets/img/star-empty.png");
                }

                &.half {
                    background-image: url("../assets/img/star-empty.png");
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
